// extracted by mini-css-extract-plugin
export default {"content":"OwnershipTransferModal_content__pQ0bs","codeField":"OwnershipTransferModal_codeField__rNH38"};